import { BadgeCheck } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import QuoteForm from "@/components/QuoteForm";
import { IMG } from "@/lib/content";
import { useSeo } from "@/hooks/useSeo";

const reassurances = [
  "Free, no-obligation quotes",
  "One-off, regular or custom schedules",
  "Residential & commercial — every budget",
  "We respond as soon as possible",
];

export default function Quote() {
  useSeo("Request a Free Cleaning Quote | RD Cleaning Services Perth", "Request a free cleaning quote from RD Cleaning Services Perth. Tell us what you need cleaned and we'll get back to you with a suitable cleaning solution.");
  return (
    <>
      <PageHero
        eyebrow="Request a Quote"
        title="Get Your Free Cleaning Quote"
        subtitle="Tell us what you need cleaned and we'll get back to you with a suitable cleaning solution."
        image={IMG.portrait}
      />
      <section className="bg-slate-50 py-16 sm:py-24">
        <div className="mx-auto grid max-w-7xl items-start gap-10 px-4 sm:px-6 lg:grid-cols-5 lg:px-8">
          <Reveal className="lg:col-span-2 lg:sticky lg:top-28">
            <h2 className="font-display text-2xl font-extrabold tracking-tight text-navy sm:text-3xl">
              A few details is all we need.
            </h2>
            <p className="mt-4 leading-relaxed text-slate-600">
              The more you can tell us about your space, the more accurate your quote will be — but don't
              worry if you're not sure. Fill in what you know and we'll work out the rest together.
            </p>
            <ul className="mt-8 space-y-4">
              {reassurances.map((t) => (
                <li key={t} className="flex items-start gap-3 text-sm font-medium text-slate-700">
                  <BadgeCheck className="mt-0.5 h-5 w-5 shrink-0 text-teal-600" /> {t}
                </li>
              ))}
            </ul>
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-3">
            <QuoteForm tid="quote-page" heading={false} />
          </Reveal>
        </div>
      </section>
    </>
  );
}
